import dayjs from 'dayjs';

export const getDateString = (date: string | Date, format = 'DD MMM YYYY'): string => {
  return dayjs(date).format(format);
};

export const getDateTimeString = (dateString: string | Date): string => dayjs(dateString).format('MMM, DD, hh:mm A');
